/**
 *
 * Details Service
 *
 */
import { FAILURE, LOADING, NAMESPACE, NOT_ASKED, CAN_UPDATE_WIRES, IS_INCOMING_WIRE } from './constants';
import reducer from './reducer';
import sagas from './sagas';
import { selectStatus, selectTransferId, selectResult, selectError, selectHasActionResolvableByCurrentUser } from './selectors';
import { detailsRequest } from './actions';

// The detailsRequest() constitutes the external API for this service.
// Calling this function initiates a request.
export {
  FAILURE,
  LOADING,
  NAMESPACE,
  NOT_ASKED,
  CAN_UPDATE_WIRES,
  IS_INCOMING_WIRE,
  reducer,
  sagas,
  selectStatus,
  selectTransferId,
  selectResult,
  selectError,
  detailsRequest,
  selectHasActionResolvableByCurrentUser,
};



// WEBPACK FOOTER //
// ./src/services/details/index.js